import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";
import {
  getExperienceBasicInfo,
  getVariationNameById,
} from "@src/store/slices/experienceBuilder/common/selectors/getVisualBuilderTrackingContext";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { mpVisualBuilderModDeleted } from "@src/utils/mixpanel";
import { constructModificationPayload } from "@src/utils/mpUtils";

export interface TrackModDeletedPayload {
  mod: EmbeddedMod;
}

export const trackModDeleted = createAsyncThunk<void, TrackModDeletedPayload>(
  "experienceBuilder/tracking/modDeleted",
  (payload, { getState }) => {
    const experienceInfo = getExperienceBasicInfo(getState());
    if (!experienceInfo) {
      return;
    }

    const { experienceId, experienceName, experienceType } = experienceInfo;
    const getVariationName = getVariationNameById(getState());
    const variationName = getVariationName(payload.mod.variationId);
    const modPayload = constructModificationPayload(payload.mod, variationName);
    const device = experienceBuilderSlice.selectors.getDevice(getState());

    mpVisualBuilderModDeleted({
      experienceId,
      experienceName,
      experienceType,
      ...modPayload,
      builderMode: device,
    });
  }
);
